var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#full_star_svg__clip0_4340_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.543 1.316l1.155 2.34c.087.18.258.302.455.328l2.58.377c.495.07.692.682.333 1.028l-1.868 1.82a.606.606 0 00-.175.534l.442 2.572a.601.601 0 01-.875.635L6.28 9.738a.603.603 0 00-.56 0L3.41 10.95a.603.603 0 01-.875-.635l.442-2.572a.594.594 0 00-.175-.534L.934 5.389a.602.602 0 01.332-1.028l2.581-.377a.613.613 0 00.455-.328l1.155-2.34a.6.6 0 011.081 0h.005z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "full_star_svg__clip0_4340_501"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgFullStar;